import StatSlide from './stat'
export default StatSlide
